// extracted by mini-css-extract-plugin
module.exports = {"container":"Settings_container__2R954","header":"Settings_header__1ASME","subHeader":"Settings_subHeader__31CJz","settingsList":"Settings_settingsList__189uc"};